import { createFileRoute } from '@tanstack/react-router'
import { CustomerSettingsPage } from '@/features/customer/settings'

export const Route = createFileRoute('/_authenticated/customer/settings')({
  component: CustomerSettingsPage,
})
